import imgstart from '@/assets/images/flow/fr_start.png'
import imgend from '@/assets/images/flow/fr_end.png'
import imguser from '@/assets/images/flow/fr_task_user.png'
import imgpanduan from '@/assets/images/flow/fr_task_panduan.png'
import imgbinglian from '@/assets/images/flow/fr_bl.png'
import imgpaita from '@/assets/images/flow/fr_pt.png'



export const elements = [{
    flag: 10,
    icon: imgstart,
    title: '开始',
    shape:'shape=ellipse;perimeter=ellipsePerimeter;',
    w:'50%',
    kuan:50,
    gao:50,
}, {
    flag: 20,
    icon: imguser,
    title: '待办任务',
    shape:null,
    w:'90%',
    kuan:110,
    gao:60,
},
    {
        flag: 40,
        icon: imgbinglian,
        title: '并连网关',
        shape: 'normalType;html=1;image=/assets/images/flow/fr_bl.png',
        w:'90%',
        kuan:60,
        gao:60,
    },
    {
        flag: 50,
        icon: imgpaita,
        title: '排它网关',
        shape: 'normalType;html=1;image=/assets/images/flow/fr_pt.png',
        w:'90%',
        kuan:60,
        gao:60,
    },
    {
    flag: 60,
    icon: imgpanduan,
    title: '判断',
    shape:'shape=rhombus;perimeter=ellipsePerimeter;arcSize=2;',
    w:'90%',
    kuan:110,
    gao:60,
}, {
    flag: 100,
    icon: imgend,
    title: '结束',
    shape:'shape=ellipse;perimeter=ellipsePerimeter;',
    w:'50%',
    kuan:60,
    gao:60,
}];
